import { render, staticRenderFns } from "./tips-progress.vue?vue&type=template&id=580ccfa0&scoped=true&"
import script from "./tips-progress.vue?vue&type=script&lang=js&"
export * from "./tips-progress.vue?vue&type=script&lang=js&"
import style0 from "./tips-progress.vue?vue&type=style&index=0&id=580ccfa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ccfa0",
  null
  
)

export default component.exports